import GraphicType from './api/GraphicType';
import FocusOutlines from './seatIcons/FocusOutlines';
import SyosSeat from './SyosSeat';

class SyosSeatFocusIndicator {
  $el: SVGGElement;

  $circle: SVGPathElement;

  $badgedCircle: SVGPathElement;

  $square: SVGPathElement;

  constructor($el: SVGGElement) {
    this.$el = $el;

    this.$circle = $el.querySelector(`#${FocusOutlines.Circle.id}`) as SVGPathElement;
    this.$badgedCircle = $el.querySelector(`#${FocusOutlines.BadgedCircle.id}`) as SVGPathElement;
    this.$square = $el.querySelector(`#${FocusOutlines.Square.id}`) as SVGPathElement;

    this.hide();
  }

  show(seat: SyosSeat) {
    this.$el.setAttribute('transform', `translate(${seat.x},${seat.y})`);

    if (seat.graphicType === GraphicType.Square) {
      show(this.$square);
      hide(this.$circle);
      hide(this.$badgedCircle);
    } else if (seat.graphicType === GraphicType.Circle) {
      show(this.$circle);
      hide(this.$badgedCircle);
      hide(this.$square);
    } else {
      show(this.$badgedCircle);
      hide(this.$circle);
      hide(this.$square);
    }

    show(this.$el);
  }

  hide() {
    hide(this.$el);
  }
}

function hide($el: SVGElement) {
  $el.style.display = 'none';
}

function show($el: SVGElement) {
  $el.style.display = '';
}

export default SyosSeatFocusIndicator;
